const NABISY = "Nabisy";

export default NABISY;
